import { render, staticRenderFns } from "./ServiceManagement.vue?vue&type=template&id=596c0ea9&scoped=true"
import script from "./ServiceManagement.vue?vue&type=script&lang=js"
export * from "./ServiceManagement.vue?vue&type=script&lang=js"
import style0 from "./ServiceManagement.vue?vue&type=style&index=0&id=596c0ea9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596c0ea9",
  null
  
)

export default component.exports